<template>
  <transition name="post" >
    <article class="post" v-if="allReady">
      <header class="post__header">
        <h2 class="post__title">{{ title }}</h2>
        <h3 class="post__meta">by {{ author }}
          <span class="post__sep"></span>
          <time>{{ prettyDate(published) }}</time>
        </h3>
      </header>
      <section class="post__body rte" v-html="content"></section>
      <footer class="post__footer">
      </footer>
    </article>
  </transition>
</template>

<script>
import VueDisqus from 'vue-disqus/VueDisqus'
import BlogNav from './BlogNav'
import { kebabify, prettyDate } from '../helpers'
import axios from 'axios'

export default {
  name: 'blog-post',
  resource: 'BlogPost',
  components: { VueDisqus, BlogNav},
  props: { post: String },

  data() {
    return {
      title: null,
      author: null,
      content: null,
      published: null,
      commentsReady: false,
      ready: false
    }
  },

  computed: {
    allReady() {
      return this.ready && this.post;
    }
  },

  methods: {
    kebabify,
    prettyDate,
    showComments() {
      // This is injected by prerender-spa-plugin on build time, we don't prerender disqus comments.
      if (window.__PRERENDER_INJECTED &&
          window.__PRERENDER_INJECTED.prerendered) {
        return;
      }
    },
    getBlogContent (){
      this.$backendService.getStoreContentInfo(this.$productStoreId).then (result => {
        this.productStoreId = result.data.productStore.productStoreId;
        this.contentWikiSpaceId = result.data.contentWikiSpaceId;
        this.$backendService.getBlogContent(this.productStoreId, this.contentWikiSpaceId, this.post).then (resultBlog => {
          this.title = resultBlog.data.blogTitle;
          this.author = resultBlog.data.author;
          this.content = resultBlog.data.blogContentText;
          this.published = resultBlog.data.publishDate;
          this.ready = true;
        })
      })
    }
  },
  mounted() {
    if (!this.post) {
      this.ready = true;
      return;
    }
    this.getBlogContent();
  },
  watch: {
    post(to, from) {
        this.getBlogContent();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlogPost.vue